import { RecipeVariants } from '@vanilla-extract/recipes';
import { root } from './Divider.css';
import classNames from 'classnames';
import { Sprinkles } from '@/style/sprinkles.css';
import { createUseRecipeHook, PropsWithClassName } from '@/style/utils/createUseRecipeHook';
import { SprinklesProps, useSprinkles, useSprinklesProps } from '@/style/utils/useSprinkles';

export type DividerStyleProps = RecipeVariants<typeof root.fn> & {
  margin?: Sprinkles['margin'];
  marginStart?: Sprinkles['margin'];
  marginEnd?: Sprinkles['margin'];
} & SprinklesProps;

const useDividerRecipe = createUseRecipeHook(root);

export const useDividerStyle = <P extends PropsWithClassName<DividerStyleProps>>({
  margin,
  marginEnd,
  marginStart,
  ...props
}: P) => {
  const inlineSprinkles: Sprinkles = {
    ...(props.direction === 'vertical'
      ? {
          marginLeft: marginStart ?? margin,
          marginRight: marginEnd ?? margin,
        }
      : {
          marginTop: marginStart ?? margin,
          marginBottom: marginEnd ?? margin,
        }),
  };

  const className = classNames(useSprinkles(inlineSprinkles), props.className);

  return useDividerRecipe(useSprinklesProps({ ...props, className }));
};
